import {Slide, SlideProps} from "@mui/material";
import React from "react";

export const MobileTransition = React.forwardRef<unknown, SlideProps>(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})
